import { useEffect, useState } from 'react';
import { collection, limit, onSnapshot, query, where } from 'firebase/firestore';
import { db } from './firebase';

export function useIsGearOwner(user) {
  const [ownsGear, setOwnsGear] = useState(false);
  const [hasWantedPosts, setHasWantedPosts] = useState(false);

  useEffect(() => {
    if (!user?.uid) {
      setOwnsGear(false);
      setHasWantedPosts(false);
      return undefined;
    }

    const gearQuery = query(
      collection(db, 'gear'),
      where('ownerId', '==', user.uid),
      limit(1)
    );

    const wantedQuery = query(
      collection(db, 'gearWanted'),
      where('requesterId', '==', user.uid),
      limit(1)
    );

    const unsubscribeGear = onSnapshot(gearQuery, (snapshot) => {
      setOwnsGear(!snapshot.empty);
    }, (error) => {
      console.error('Gear owner listener error:', error);
      setOwnsGear(false);
    });

    const unsubscribeWanted = onSnapshot(wantedQuery, (snapshot) => {
      setHasWantedPosts(!snapshot.empty);
    }, (error) => {
      console.error('Gear wanted listener error:', error);
      setHasWantedPosts(false);
    });

    return () => {
      unsubscribeGear();
      unsubscribeWanted();
    };
  }, [user?.uid]);

  return ownsGear || hasWantedPosts;
}